import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import { translate } from "react-admin";

/**
 * Componente che gestisce:
 * -) titolo scheda browser
 * -) hover + click sul titolo
 */

class DynamicTitleWithTooltip extends React.Component {
  componentDidMount() {
    this.updateDocumentTitle();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.record !== this.props.record) {
      this.updateDocumentTitle();
    }
  }

  componentWillUnmount() {
    document.title = "SensIC"; // puoi parametrizzarlo se vuoi
  }

  updateDocumentTitle() {
    const { record, translate, getTitle } = this.props;
    if (record && getTitle) {
      document.title = getTitle(record, translate);
    }
  }

  render() {
    const { record, translate, getTitle } = this.props;
    if (!record || !getTitle) return null;
    const title = getTitle(record, translate);
    return <ResponsiveTooltip title={title}>{title}</ResponsiveTooltip>;
  }
}

const ResponsiveTooltip = ({ title, children }) => {
  const [open, setOpen] = React.useState(false);

  const handleClick = () => setOpen((prev) => !prev);
  const handleClickAway = () => setOpen(false);
  const handleMouseEnter = () => setOpen(true);
  const handleMouseLeave = () => setOpen(false);

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div
        onClick={handleClick}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={{ display: "inline-block", cursor: "pointer" }}
      >
        <Tooltip title={title} open={open} arrow>
          <span>{children}</span>
        </Tooltip>
      </div>
    </ClickAwayListener>
  );
};

export default translate(DynamicTitleWithTooltip);
